export default "__VITE_ASSET__CW4_DWLV__"